export const PAYMENT_STATUS = {
    PENDING: 'pending',
    ERROR: 'error',
    OK: 'ok',
    CANCEL: 'cancel',
};